<template>
    <div class="panel-price-box">
        <slot name="priceIcon"></slot>
        <span class="panel-price-box__price">{{ price }}</span>
        <slot name="priceMeasure"></slot>
    </div>
</template>

<script>
export default {
    name: 'PanelPriceBpx',

    props: {
        price: {
            type: Number,
            default: 1,
        },
    },
};
</script>

<style src="./PanelPriceBox.scss" lang="scss" scoped></style>
